<template>
  <div>
    <v-container class="feedback-main-container" fluid>
      <v-btn
        color="red feedback-open-btn white--text"
        @click="openFeedbackForm">
        {{ btnText }}
        <v-icon dark right>sentiment_satisfied_alt</v-icon>
      </v-btn>
      <v-slide-y-reverse-transition mode="out-in">
        <div class="feedback-form elevation-6" v-if="showFeedbackForm">
          <div class="feedback-form-main">
            <v-layout class="form-header">
              <v-flex class="box-title-feedback">
                  <strong>{{btnText}}</strong>
              </v-flex>
              <v-spacer></v-spacer>
              <v-btn icon class="ma-0" @click="closeFeedbackForm">
                <v-icon class="feedback-close-btn">close</v-icon>
              </v-btn>
            </v-layout>
            <v-progress-linear
              height="2"
              color="red"
              v-show="true"
              :indeterminate="false"
              class="progress-line ma-0"
              background-color="white"
            ></v-progress-linear>
            <v-divider class="mt-0"></v-divider>

            <div class="feedback-form-body">
              <div>
                <v-subheader>{{ firstFieldLabel }}</v-subheader>
                <v-layout row wrap d-flex>
                  <v-flex xs4 sm4 md4 offset-xs4 offset-sd4 offset-md4>
                    <v-btn-toggle v-model="satisfaction" mandatory>
                      <v-btn flat>
                        <v-icon :class="{'green--text': satisfaction === 0}">thumb_up_alt</v-icon>
                      </v-btn>
                      <v-btn flat>
                        <v-icon :class="{'red--text': satisfaction === 1}">thumb_down_alt</v-icon>
                      </v-btn>                
                    </v-btn-toggle>
                  </v-flex>
                </v-layout>
              </div>

              <v-layout column>
                <v-flex md12>
                  <v-subheader>{{ secondFieldLabel }}</v-subheader>
                </v-flex>

                <v-flex md12>
                  <textarea class="feedback-textarea" v-model="formTextarea" rows="8"/>
                </v-flex>
              </v-layout>

              <v-layout class="feedback-form-footer">
                <v-flex align-end d-flex>
                  <v-btn class="ma-0" small @click="sendFormData">Enviar</v-btn>
                </v-flex>
              </v-layout>

              <v-slide-y-reverse-transition mode="out-in">
                <div class="thanks-overlay" v-if="dataSent">{{ thanksMessage }}</div>
              </v-slide-y-reverse-transition>
            </div>
          </div>
        </div>
      </v-slide-y-reverse-transition>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    token: {
      type: String
    },
    generalFeedback: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      thanksMessage: 'Obrigado pela sua opinião!',
      secondFieldLabel: 'Comente:',
      sendBtnText: 'Enviar',
      formTextarea: '',
      showFeedbackForm: false,
      satisfaction: 0,
      dataSent: false
    }
  },
  computed: {
    btnText () {
      return this.generalFeedback ? 'Feedback' : 'Dê sua opinião'
    },
    firstFieldLabel () {
      return this.generalFeedback ? 'Nos conte sobre sua experiência.' : 'Achou o valor atrativo?'
    }
  },
  methods: {
    openFeedbackForm () {
      this.showFeedbackForm = true
    },

    closeFeedbackForm () {
      this.showFeedbackForm = false
    },

    sendFormData () {
      this.$store.commit('updateSatisfaction', this.satisfaction === 0)
      this.$store.commit('updateObservation', this.formTextarea)

      this.$store.dispatch('sendHotsiteFeedback', this.token)
        .then(({ data }) => {
          this.dataSent = true

          setTimeout(() => {
            this.closeFeedbackForm()
          }, 2000)
        })
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style scoped>
.feedback-main-container {
  padding-top: 0;
  padding-bottom: 0;
}

.feedback-close-btn {
  cursor: pointer;
}

.feedback-form {
  cursor: auto;
  width: 25em;
  max-width: 320px;
  margin: 0 auto;
  background: #fff;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 1em;
}

.feedback-textarea {
  width: 100%;
  max-width: 100%;
  border: 1px solid #ccc;
  padding: .5em;
}

.feedback-form .subheader {
  padding: 0;
}

.feedback-form-body {
  position: relative;
}

.feedback-form-footer {
  padding: .5em 0;
}

.thanks-overlay {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
}

 .box-title-feedback{
  margin-top: 6px;
  color: #6d7884;
  font-size: 18px;
}

@media all and (max-width: 720px) {
  .feedback-main-container {
    max-width: 320px;
    margin: 0 auto;
    overflow: hidden;
    padding: 0;
  }

  .feedback-form {
    left: 48%;
    transform: translateX(-50%);
  }

  .feedback-open-btn {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// Feedback.vue?86e5ab52